import { render } from "./SelectTrigger.vue?vue&type=template&id=168c119f&ts=true"
import script from "./SelectTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/select/SelectTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "168c119f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('168c119f', __exports__)) {
    api.reload('168c119f', __exports__)
  }
  
  module.hot.accept("./SelectTrigger.vue?vue&type=template&id=168c119f&ts=true", () => {
    api.rerender('168c119f', render)
  })

}


export default __exports__